import styles from "@/components/chat-message.module.css";
import { JSX } from "react";
import ReactMarkdown from "react-markdown";

interface ChatMessageProps {
	isLoading: boolean;
	message: string;
}

function ChatMessage({ isLoading, message }: ChatMessageProps): JSX.Element {
	if (isLoading) {
		const dots = Array.from({ length: 3 }, (_, i) => (
			<span
				className={styles["typing"]}
				key={i}
			></span>
		));
		return <div className={styles["message-container"]}>{dots}</div>;
	}

	return (
		<div className={styles["message-container"]}>
			<ReactMarkdown>{message}</ReactMarkdown>
		</div>
	);
}

export default ChatMessage;
